import { render, staticRenderFns } from "./CenterScreenNotification.vue?vue&type=template&id=17b3e87c&scoped=true&"
import script from "./CenterScreenNotification.vue?vue&type=script&lang=js&"
export * from "./CenterScreenNotification.vue?vue&type=script&lang=js&"
import style0 from "./CenterScreenNotification.vue?vue&type=style&index=0&id=17b3e87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b3e87c",
  null
  
)

export default component.exports